import Dialex from './Dialex';
export { Dialex };



// WEBPACK FOOTER //
// ./src/index.js